module.exports = __webpack_public_path__ + "static/media/kline_area.653648d7.svg";